import React, { useState } from 'react';
import styled from 'styled-components';
import { disclaimerService } from '../../services/disclaimerService';
import { logger } from '../../utils/logger';

const BannerContainer = styled.div`
  background-color: var(--secondary);
  color: var(--dark);
  padding: 1rem;
  margin-bottom: 1.5rem;
  border-radius: 8px;
  display: ${props => props.visible ? 'flex' : 'none'};
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const BannerText = styled.div`
  flex: 1;
  p {
    margin: 0;
  }
`;

const BannerActions = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const Button = styled.button`
  background-color: ${props => props.primary ? 'var(--primary)' : 'transparent'};
  color: ${props => props.primary ? 'white' : 'var(--primary)'};
  border: ${props => props.primary ? 'none' : '1px solid var(--primary)'};
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => props.primary ? 'var(--primary-dark)' : 'rgba(233, 64, 87, 0.1)'};
  }
`;

const DisclaimerBanner = ({ userEmail }) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(true);

  // Check if the user has already acknowledged the disclaimer
  const checkAcknowledgment = async () => {
    if (!userEmail) {
      setVisible(false);
      setLoading(false);
      return;
    }

    try {
      const acknowledged = await disclaimerService.checkDisclaimerAcknowledgment(userEmail);
      setVisible(!acknowledged);
      setLoading(false);
    } catch (error) {
      logger.error('Error checking disclaimer acknowledgment:', error);
      // If there's an error, show the banner to be safe
      setVisible(true);
      setLoading(false);
    }
  };

  // Handle acknowledgment
  const handleAcknowledge = async () => {
    if (!userEmail) return;

    try {
      await disclaimerService.recordDisclaimerAcknowledgment(userEmail);
      setVisible(false);
    } catch (error) {
      logger.error('Error recording disclaimer acknowledgment:', error);
      alert('There was an error acknowledging the disclaimer. Please try again.');
    }
  };

  // Check acknowledgment when the component mounts or userEmail changes
  React.useEffect(() => {
    checkAcknowledgment();
  }, [userEmail]);

  if (loading) return null;

  return (
    <BannerContainer visible={visible}>
      <BannerText>
        <p>
          <strong>Medical Disclaimer:</strong> The information provided by Dozzy is not a substitute for professional medical advice. 
          Always consult with a healthcare professional before making changes to your child's sleep routine.
        </p>
      </BannerText>
      <BannerActions>
        <Button primary onClick={handleAcknowledge}>I Understand</Button>
      </BannerActions>
    </BannerContainer>
  );
};

export default DisclaimerBanner;
